/* tslint:disable */
/* eslint-disable */
/* @relayHash 9c28aa927a6d4ee29ff476337d9563b4 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MEMBER" | "MODERATOR" | "QUESTION" | "REVIEW" | "STAFF" | "UNANSWERED" | "%future added value";
export type AllCommentsTabQueryVariables = {
    storyID?: string | null;
    storyURL?: string | null;
    commentsOrderBy?: COMMENT_SORT | null;
    tag?: TAG | null;
    storyMode?: STORY_MODE | null;
    flattenReplies: boolean;
    ratingFilter?: number | null;
    refreshStream?: boolean | null;
};
export type AllCommentsTabQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_viewer">;
    } | null;
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_story">;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_settings">;
    };
};
export type AllCommentsTabQuery = {
    readonly response: AllCommentsTabQueryResponse;
    readonly variables: AllCommentsTabQueryVariables;
};



/*
query AllCommentsTabQuery(
  $storyID: ID
  $storyURL: String
  $commentsOrderBy: COMMENT_SORT
  $tag: TAG
  $storyMode: STORY_MODE
  $flattenReplies: Boolean!
  $ratingFilter: Int
  $refreshStream: Boolean
) {
  viewer {
    ...AllCommentsTabContainer_viewer
    id
  }
  story: stream(id: $storyID, url: $storyURL, mode: $storyMode) {
    ...AllCommentsTabContainer_story_1wjmR8
    id
  }
  settings {
    ...AllCommentsTabContainer_settings
    id
  }
}

fragment AllCommentsTabCommentContainer_comment_4768Eu on Comment {
  id
  seen
  ...CommentContainer_comment
  ...ReplyListContainer1_comment_4768Eu
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
}

fragment AllCommentsTabCommentContainer_settings on Settings {
  ...ReplyListContainer1_settings
  ...CommentContainer_settings
}

fragment AllCommentsTabCommentContainer_story on Story {
  ...ReplyListContainer1_story
  ...CommentContainer_story
}

fragment AllCommentsTabCommentContainer_viewer on User {
  id
  ...ReplyListContainer1_viewer
  ...CommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
}

fragment AllCommentsTabContainer_settings on Settings {
  reaction {
    sortLabel
  }
  inPageNotifications {
    active
  }
  disableCommenting {
    enabled
  }
  featureFlags
  ...PostCommentFormContainer_settings
  ...ViewersWatchingContainer_settings
  ...AllCommentsTabCommentContainer_settings
}

fragment AllCommentsTabContainer_story_1wjmR8 on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
    mode
  }
  commentCounts {
    totalPublished
    tags {
      REVIEW
      QUESTION
    }
  }
  comments(first: 20, orderBy: $commentsOrderBy, tag: $tag, rating: $ratingFilter, refreshStream: $refreshStream) {
    edges {
      node {
        id
        seen
        author {
          id
        }
        deleted
        allChildComments {
          edges {
            node {
              ancestorIDs
              id
              seen
              author {
                id
              }
              deleted
            }
          }
        }
        ...AllCommentsTabCommentContainer_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...PostCommentFormContainer_story
  ...CreateCommentReplyMutation_story
  ...CreateCommentMutation_story
  ...ViewersWatchingContainer_story
  ...AllCommentsTabCommentContainer_story
}

fragment AllCommentsTabContainer_viewer on User {
  ...AllCommentsTabCommentContainer_viewer
  ...CreateCommentReplyMutation_viewer
  ...CreateCommentMutation_viewer
  ...PostCommentFormContainer_viewer
  id
  status {
    current
  }
  ignoredUsers {
    id
  }
  inPageNotifications {
    enabled
  }
}

fragment ArchivedReportFlowContainer_comment on Comment {
  id
  story {
    url
    id
  }
}

fragment ArchivedReportFlowContainer_settings on Settings {
  organization {
    name
    contactEmail
  }
}

fragment AuthorBadgesContainer_settings on Settings {
  flairBadges {
    flairBadgesEnabled
    badges {
      name
      url
    }
  }
}

fragment BadgeTagContainer_settings on Settings {
  badges {
    staffLabel
    adminLabel
    moderatorLabel
    memberLabel
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment CaretContainer_settings on Settings {
  ...ModerationDropdownContainer_settings
}

fragment CaretContainer_story on Story {
  ...ModerationDropdownContainer_story
}

fragment CaretContainer_viewer on User {
  ...ModerationDropdownContainer_viewer
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
    avatar
    badges
    featuredCommenter
    newCommenter
  }
  parent {
    id
    author {
      username
      id
    }
  }
  body
  createdAt
  status
  rating
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  actionCounts {
    reaction {
      total
    }
  }
  viewerActionPresence {
    dontAgree
    flag
  }
  seen
  canReply
  ...CaretContainer_comment
  ...EditCommentFormContainer_comment
  ...MediaSectionContainer_comment
  ...ReactionButtonContainer_comment
  ...ModerationRejectedTombstoneContainer_comment
  ...ReplyCommentFormContainer_comment
  ...ReportButton_comment
  ...ReportFlowContainer_comment
  ...UsernameContainer_comment
  ...UsernameWithPopoverContainer_comment
  ...UserTagsContainer_comment
  ...ArchivedReportFlowContainer_comment
}

fragment CommentContainer_settings on Settings {
  flattenReplies
  collapseReplies
  disableCommenting {
    enabled
  }
  topCommenter {
    enabled
  }
  newCommenter {
    enabled
  }
  featureFlags
  ...CaretContainer_settings
  ...EditCommentFormContainer_settings
  ...MediaSectionContainer_settings
  ...ReactionButtonContainer_settings
  ...ModerationRejectedTombstoneContainer_settings
  ...ReplyCommentFormContainer_settings
  ...ReportFlowContainer_settings
  ...UsernameWithPopoverContainer_settings
  ...UserTagsContainer_settings
  ...ArchivedReportFlowContainer_settings
  ...AuthorBadgesContainer_settings
  ...ReportButton_settings
}

fragment CommentContainer_story on Story {
  id
  url
  isClosed
  canModerate
  settings {
    mode
  }
  isArchiving
  isArchived
  ...CaretContainer_story
  ...EditCommentFormContainer_story
  ...PermalinkButtonContainer_story
  ...ReplyCommentFormContainer_story
  ...UserTagsContainer_story
  ...ModerationRejectedTombstoneContainer_story
}

fragment CommentContainer_viewer on User {
  id
  status {
    current
  }
  ignoredUsers {
    id
  }
  badges
  role
  scheduledDeletionDate
  mediaSettings {
    unfurlEmbeds
  }
  ...UsernameWithPopoverContainer_viewer
  ...ReactionButtonContainer_viewer
  ...ReportFlowContainer_viewer
  ...ReportButton_viewer
  ...CaretContainer_viewer
  ...ModerationRejectedTombstoneContainer_viewer
}

fragment CopyCommentEmbedCodeContainer_comment on Comment {
  id
  author {
    id
    username
  }
  body
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
      }
      ... on TwitterMedia {
        url
      }
      ... on BlueskyMedia {
        url
      }
      ... on YouTubeMedia {
        url
      }
      ... on ExternalMedia {
        url
      }
    }
  }
}

fragment CopyCommentEmbedCodeContainer_settings on Settings {
  embeddedComments {
    allowReplies
  }
  reaction {
    label
  }
}

fragment CopyCommentEmbedCodeContainer_story on Story {
  url
}

fragment CreateCommentMutation_story on Story {
  id
  url
  viewerRating {
    id
    tags {
      code
    }
    rating
  }
  settings {
    moderation
    mode
    live {
      enabled
    }
    experts {
      id
    }
  }
  ratings {
    count
    average
  }
}

fragment CreateCommentMutation_viewer on User {
  id
  avatar
  badges
  bio
  createdAt
  role
  username
  featuredCommenter
  newCommenter
  status {
    current
    ban {
      active
    }
  }
}

fragment CreateCommentReplyMutation_story on Story {
  url
  settings {
    moderation
  }
}

fragment CreateCommentReplyMutation_viewer on User {
  role
  badges
  createdAt
  featuredCommenter
  status {
    current
    ban {
      active
    }
  }
}

fragment DeletedTombstoneContainer_comment on Comment {
  deleted
  id
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  revision {
    id
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
        title
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
  }
  author {
    username
    id
  }
  editing {
    editableUntil
  }
  site {
    id
  }
}

fragment EditCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  media {
    twitter {
      enabled
    }
    bluesky {
      enabled
    }
    youtube {
      enabled
    }
    gifs {
      enabled
      key
      maxRating
      provider
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment EditCommentFormContainer_story on Story {
  id
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  id
  author {
    id
    username
  }
}

fragment IgnoredTombstoneOrHideContainer_viewer on User {
  ignoredUsers {
    id
  }
}

fragment LocalReplyListContainer_comment on Comment {
  id
}

fragment LocalReplyListContainer_settings on Settings {
  ...ReplyListCommentContainer_settings
}

fragment LocalReplyListContainer_story on Story {
  ...ReplyListCommentContainer_story
}

fragment LocalReplyListContainer_viewer on User {
  ...ReplyListCommentContainer_viewer
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment MediaSectionContainer_settings on Settings {
  media {
    twitter {
      enabled
    }
    bluesky {
      enabled
    }
    youtube {
      enabled
    }
    gifs {
      enabled
      provider
    }
    external {
      enabled
    }
  }
}

fragment MessageBoxContainer_story on Story {
  settings {
    messageBox {
      content
      icon
    }
    mode
  }
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  body
  revision {
    id
  }
  status
  tags {
    code
  }
  ...CopyCommentEmbedCodeContainer_comment
}

fragment ModerationActionsContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
  ...CopyCommentEmbedCodeContainer_settings
}

fragment ModerationActionsContainer_story on Story {
  id
  settings {
    mode
  }
  ...CopyCommentEmbedCodeContainer_story
}

fragment ModerationActionsContainer_viewer on User {
  id
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationDropdownContainer_settings on Settings {
  ...ModerationActionsContainer_settings
  ...UserBanPopoverContainer_settings
}

fragment ModerationDropdownContainer_story on Story {
  id
  ...ModerationActionsContainer_story
  ...UserBanPopoverContainer_story
}

fragment ModerationDropdownContainer_viewer on User {
  ...ModerationActionsContainer_viewer
  ...UserBanPopoverContainer_viewer
}

fragment ModerationRejectedTombstoneContainer_comment on Comment {
  id
  ...CaretContainer_comment
}

fragment ModerationRejectedTombstoneContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
  ...CaretContainer_settings
}

fragment ModerationRejectedTombstoneContainer_story on Story {
  ...CaretContainer_story
}

fragment ModerationRejectedTombstoneContainer_viewer on User {
  ...CaretContainer_viewer
}

fragment PermalinkButtonContainer_story on Story {
  url
}

fragment PostCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    bluesky {
      enabled
    }
    youtube {
      enabled
    }
    gifs {
      enabled
      key
      maxRating
      provider
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
  featureFlags
}

fragment PostCommentFormContainer_story on Story {
  id
  isClosed
  site {
    id
  }
  viewerRating {
    id
    status
    tags {
      code
    }
    rating
  }
  settings {
    messageBox {
      enabled
    }
    experts {
      id
    }
    mode
  }
  ...MessageBoxContainer_story
}

fragment PostCommentFormContainer_viewer on User {
  id
  scheduledDeletionDate
}

fragment RTEContainer_config on RTEConfiguration {
  enabled
  strikethrough
  spoiler
  sarcasm
}

fragment ReactionButtonContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  viewerActionPresence {
    reaction
  }
  actionCounts {
    reaction {
      total
    }
  }
}

fragment ReactionButtonContainer_settings on Settings {
  reaction {
    label
    labelActive
    icon
    iconActive
  }
}

fragment ReactionButtonContainer_viewer on User {
  id
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  site {
    id
  }
  author {
    username
    id
  }
  revision {
    id
  }
  ...ReplyEditedWarningContainer_comment
}

fragment ReplyCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
  media {
    twitter {
      enabled
    }
    bluesky {
      enabled
    }
    youtube {
      enabled
    }
    gifs {
      enabled
      key
      maxRating
      provider
    }
    external {
      enabled
    }
  }
  rte {
    ...RTEContainer_config
  }
}

fragment ReplyCommentFormContainer_story on Story {
  id
  isClosed
}

fragment ReplyEditedWarningContainer_comment on Comment {
  editing {
    edited
  }
  revision {
    id
  }
}

fragment ReplyListCommentContainer_comment on Comment {
  id
  ...CommentContainer_comment
  ...IgnoredTombstoneOrHideContainer_comment
  ...DeletedTombstoneContainer_comment
}

fragment ReplyListCommentContainer_settings on Settings {
  ...CommentContainer_settings
  flattenReplies
  collapseReplies
  featureFlags
}

fragment ReplyListCommentContainer_story on Story {
  ...CommentContainer_story
}

fragment ReplyListCommentContainer_viewer on User {
  ...CommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
}

fragment ReplyListContainer1_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer2_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer1_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainer2_settings
}

fragment ReplyListContainer1_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer2_story
}

fragment ReplyListContainer1_viewer on User {
  id
  ...ReplyListCommentContainer_viewer
  ...ReplyListContainer2_viewer
}

fragment ReplyListContainer2_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer3_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer2_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainer3_settings
}

fragment ReplyListContainer2_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer3_story
}

fragment ReplyListContainer2_viewer on User {
  id
  ...ReplyListCommentContainer_viewer
  ...ReplyListContainer3_viewer
}

fragment ReplyListContainer3_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer4_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer3_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainer4_settings
}

fragment ReplyListContainer3_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer4_story
}

fragment ReplyListContainer3_viewer on User {
  id
  ...ReplyListCommentContainer_viewer
  ...ReplyListContainer4_viewer
}

fragment ReplyListContainer4_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer5_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer4_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainer5_settings
}

fragment ReplyListContainer4_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer5_story
}

fragment ReplyListContainer4_viewer on User {
  id
  ...ReplyListCommentContainer_viewer
  ...ReplyListContainer5_viewer
}

fragment ReplyListContainer5_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainer6_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer5_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainer6_settings
}

fragment ReplyListContainer5_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainer6_story
}

fragment ReplyListContainer5_viewer on User {
  id
  ...ReplyListCommentContainer_viewer
  ...ReplyListContainer6_viewer
}

fragment ReplyListContainer6_comment_4768Eu on Comment {
  status
  id
  ...ReplyListContainer_comment_4768Eu
  replies(first: 10, orderBy: CREATED_AT_ASC, refreshStream: $refreshStream) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        ...ReplyListContainerLast_comment_4768Eu
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainer6_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
  ...ReplyListContainerLast_settings
}

fragment ReplyListContainer6_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
  ...ReplyListContainerLast_story
}

fragment ReplyListContainer6_viewer on User {
  id
  ...ReplyListCommentContainer_viewer
  ...ReplyListContainerLast_viewer
}

fragment ReplyListContainerLastFlattened_comment on Comment {
  status
  id
  ...ReplyListContainer_comment_1fYj9E
  replies(first: 10, orderBy: CREATED_AT_ASC, flatten: $flattenReplies, refreshStream: false) {
    edges {
      node {
        id
        replyCount
        ...ReplyListCommentContainer_comment
        __typename
      }
      __typename
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ReplyListContainerLastFlattened_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListCommentContainer_settings
}

fragment ReplyListContainerLastFlattened_story on Story {
  id
  isClosed
  closedAt
  settings {
    live {
      enabled
    }
  }
  ...ReplyListCommentContainer_story
}

fragment ReplyListContainerLastFlattened_viewer on User {
  id
  ...ReplyListCommentContainer_viewer
}

fragment ReplyListContainerLast_comment_4768Eu on Comment {
  ...LocalReplyListContainer_comment @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_comment @include(if: $flattenReplies)
}

fragment ReplyListContainerLast_settings on Settings {
  ...LocalReplyListContainer_settings @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_settings @include(if: $flattenReplies)
}

fragment ReplyListContainerLast_story on Story {
  ...LocalReplyListContainer_story @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_story @include(if: $flattenReplies)
}

fragment ReplyListContainerLast_viewer on User {
  id
  ...LocalReplyListContainer_viewer @skip(if: $flattenReplies)
  ...ReplyListContainerLastFlattened_viewer @include(if: $flattenReplies)
}

fragment ReplyListContainer_comment_1fYj9E on Comment {
  id
  status
}

fragment ReplyListContainer_comment_4768Eu on Comment {
  id
  status
}

fragment ReportButton_comment on Comment {
  id
  author {
    username
    id
  }
  viewerActionPresence {
    dontAgree
    flag
    illegal
  }
}

fragment ReportButton_settings on Settings {
  dsa {
    enabled
  }
}

fragment ReportButton_viewer on User {
  id
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
  story {
    url
    id
  }
}

fragment ReportCommentFormContainer_settings on Settings {
  memberBios
}

fragment ReportFlowContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment ReportFlowContainer_settings on Settings {
  dsa {
    enabled
  }
  ...ReportCommentFormContainer_settings
}

fragment ReportFlowContainer_viewer on User {
  id
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment UserBanPopoverContainer_settings on Settings {
  auth {
    integrations {
      sso {
        enabled
        targetFilter {
          admin
        }
      }
    }
  }
}

fragment UserBanPopoverContainer_story on Story {
  id
  site {
    id
    name
  }
}

fragment UserBanPopoverContainer_viewer on User {
  moderationScopes {
    scoped
  }
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment UserPopoverContainer_settings on Settings {
  ...UserPopoverOverviewContainer_settings
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverContainer_viewer on User {
  ...UserPopoverOverviewContainer_viewer
}

fragment UserPopoverOverviewContainer_settings on Settings {
  memberBios
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
  bio
}

fragment UserPopoverOverviewContainer_viewer on User {
  id
  ignoredUsers {
    id
  }
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UserTagsContainer_settings on Settings {
  ...BadgeTagContainer_settings
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment UsernameContainer_comment on Comment {
  id
  author {
    username
    id
  }
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}

fragment UsernameWithPopoverContainer_settings on Settings {
  ...UserPopoverContainer_settings
}

fragment UsernameWithPopoverContainer_viewer on User {
  ...UserPopoverContainer_viewer
}

fragment ViewersWatchingContainer_settings on Settings {
  disableCommenting {
    enabled
  }
}

fragment ViewersWatchingContainer_story on Story {
  id
  viewerCount
  isClosed
  settings {
    live {
      enabled
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsOrderBy"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "flattenReplies"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ratingFilter"
    } as any), v3 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "refreshStream"
    } as any), v4 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v5 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyMode"
    } as any), v6 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyURL"
    } as any), v7 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tag"
    } as any), v8 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "mode",
            "variableName": "storyMode"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v9 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "commentsOrderBy"
    } as any), v10 = ({
        "kind": "Variable",
        "name": "refreshStream",
        "variableName": "refreshStream"
    } as any), v11 = ({
        "kind": "Variable",
        "name": "tag",
        "variableName": "tag"
    } as any), v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v13 = [
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
        } as any)
    ], v14 = [
        (v12 /*: any*/)
    ], v15 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "badges",
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "featuredCommenter",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avatar",
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bio",
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v21 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newCommenter",
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v23 = [
        (v22 /*: any*/)
    ], v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "icon",
        "storageKey": null
    } as any), v25 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 20
        } as any),
        (v9 /*: any*/),
        ({
            "kind": "Variable",
            "name": "rating",
            "variableName": "ratingFilter"
        } as any),
        (v10 /*: any*/),
        (v11 /*: any*/)
    ], v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "seen",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            (v12 /*: any*/),
            (v20 /*: any*/),
            (v18 /*: any*/),
            (v15 /*: any*/),
            (v17 /*: any*/),
            (v21 /*: any*/),
            (v16 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoreable",
                "storageKey": null
            },
            (v19 /*: any*/)
        ],
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
    } as any), v29 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "allChildComments",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ancestorIDs",
                                "storageKey": null
                            },
                            (v12 /*: any*/),
                            (v26 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": (v14 /*: any*/),
                                "storageKey": null
                            },
                            (v28 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v30 = ({
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
            (v12 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v20 /*: any*/),
                    (v12 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v31 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v32 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v33 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rating",
        "storageKey": null
    } as any), v34 = ({
        "alias": null,
        "args": null,
        "concreteType": "EditInfo",
        "kind": "LinkedField",
        "name": "editing",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "edited",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editableUntil",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v35 = ({
        "alias": null,
        "args": null,
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v36 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionCounts",
        "kind": "LinkedField",
        "name": "actionCounts",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "kind": "LinkedField",
                "name": "reaction",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v37 = ({
        "alias": null,
        "args": null,
        "concreteType": "ActionPresence",
        "kind": "LinkedField",
        "name": "viewerActionPresence",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dontAgree",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flag",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reaction",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "illegal",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v38 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canReply",
        "storageKey": null
    } as any), v39 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v40 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v41 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any), v42 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v43 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v44 = [
        (v40 /*: any*/),
        (v42 /*: any*/)
    ], v45 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentRevision",
        "kind": "LinkedField",
        "name": "revision",
        "plural": false,
        "selections": [
            (v12 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                    (v39 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v40 /*: any*/),
                            (v41 /*: any*/),
                            (v42 /*: any*/),
                            (v43 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "still",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "video",
                                "storageKey": null
                            }
                        ],
                        "type": "GiphyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v44 /*: any*/),
                        "type": "TwitterMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": (v44 /*: any*/),
                        "type": "BlueskyMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v40 /*: any*/),
                            (v42 /*: any*/),
                            (v43 /*: any*/)
                        ],
                        "type": "YouTubeMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v40 /*: any*/)
                        ],
                        "type": "ExternalMedia",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v40 /*: any*/),
                            (v41 /*: any*/)
                        ],
                        "type": "TenorMedia",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v46 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": (v14 /*: any*/),
        "storageKey": null
    } as any), v47 = ({
        "alias": null,
        "args": null,
        "concreteType": "Story",
        "kind": "LinkedField",
        "name": "story",
        "plural": false,
        "selections": [
            (v40 /*: any*/),
            (v12 /*: any*/)
        ],
        "storageKey": null
    } as any), v48 = ({
        "kind": "Literal",
        "name": "first",
        "value": 10
    } as any), v49 = ({
        "kind": "Literal",
        "name": "orderBy",
        "value": "CREATED_AT_ASC"
    } as any), v50 = [
        (v48 /*: any*/),
        (v49 /*: any*/),
        (v10 /*: any*/)
    ], v51 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v52 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spamBanned",
        "storageKey": null
    } as any), v53 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any), v54 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastViewerAction",
        "storageKey": null
    } as any), v55 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasTraversalFocus",
        "storageKey": null
    } as any), v56 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enteredLive",
        "storageKey": null
    } as any), v57 = ({
        "kind": "ClientExtension",
        "selections": [
            (v52 /*: any*/),
            (v53 /*: any*/),
            (v54 /*: any*/),
            (v55 /*: any*/),
            (v56 /*: any*/)
        ]
    } as any), v58 = [
        ({
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "localReplies",
            "plural": true,
            "selections": [
                (v12 /*: any*/),
                (v56 /*: any*/),
                (v54 /*: any*/),
                (v27 /*: any*/),
                (v30 /*: any*/),
                (v31 /*: any*/),
                (v16 /*: any*/),
                (v32 /*: any*/),
                (v33 /*: any*/),
                (v34 /*: any*/),
                (v35 /*: any*/),
                (v53 /*: any*/),
                (v28 /*: any*/),
                (v36 /*: any*/),
                (v37 /*: any*/),
                (v55 /*: any*/),
                (v26 /*: any*/),
                (v38 /*: any*/),
                (v52 /*: any*/),
                (v45 /*: any*/),
                (v46 /*: any*/),
                (v47 /*: any*/)
            ],
            "storageKey": null
        } as any)
    ], v59 = ({
        "kind": "Literal",
        "name": "refreshStream",
        "value": false
    } as any), v60 = [
        (v48 /*: any*/),
        ({
            "kind": "Variable",
            "name": "flatten",
            "variableName": "flattenReplies"
        } as any),
        (v49 /*: any*/),
        (v59 /*: any*/)
    ], v61 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v62 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v63 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v12 /*: any*/),
                    (v51 /*: any*/),
                    (v56 /*: any*/),
                    (v54 /*: any*/),
                    (v27 /*: any*/),
                    (v30 /*: any*/),
                    (v31 /*: any*/),
                    (v16 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v35 /*: any*/),
                    (v53 /*: any*/),
                    (v28 /*: any*/),
                    (v36 /*: any*/),
                    (v37 /*: any*/),
                    (v55 /*: any*/),
                    (v26 /*: any*/),
                    (v38 /*: any*/),
                    (v52 /*: any*/),
                    (v45 /*: any*/),
                    (v46 /*: any*/),
                    (v47 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v64 = [
        "orderBy",
        "refreshStream"
    ], v65 = ({
        "alias": null,
        "args": (v60 /*: any*/),
        "filters": (v64 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v66 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": false,
        "selections": (v58 /*: any*/)
    } as any), v67 = ({
        "condition": "flattenReplies",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": null,
                "args": (v60 /*: any*/),
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "replies",
                "plural": false,
                "selections": [
                    (v63 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v12 /*: any*/),
                                    (v51 /*: any*/),
                                    (v56 /*: any*/),
                                    (v54 /*: any*/),
                                    (v27 /*: any*/),
                                    (v30 /*: any*/),
                                    (v31 /*: any*/),
                                    (v16 /*: any*/),
                                    (v32 /*: any*/),
                                    (v33 /*: any*/),
                                    (v34 /*: any*/),
                                    (v35 /*: any*/),
                                    (v53 /*: any*/),
                                    (v28 /*: any*/),
                                    (v36 /*: any*/),
                                    (v37 /*: any*/),
                                    (v55 /*: any*/),
                                    (v26 /*: any*/),
                                    (v38 /*: any*/),
                                    (v52 /*: any*/),
                                    (v45 /*: any*/),
                                    (v46 /*: any*/),
                                    (v47 /*: any*/),
                                    (v39 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v39 /*: any*/),
                            (v61 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v62 /*: any*/)
                ],
                "storageKey": null
            },
            (v65 /*: any*/)
        ]
    } as any), v68 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v12 /*: any*/),
                    (v51 /*: any*/),
                    (v56 /*: any*/),
                    (v54 /*: any*/),
                    (v27 /*: any*/),
                    (v30 /*: any*/),
                    (v31 /*: any*/),
                    (v16 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v35 /*: any*/),
                    (v53 /*: any*/),
                    (v28 /*: any*/),
                    (v36 /*: any*/),
                    (v37 /*: any*/),
                    (v55 /*: any*/),
                    (v26 /*: any*/),
                    (v38 /*: any*/),
                    (v52 /*: any*/),
                    (v45 /*: any*/),
                    (v46 /*: any*/),
                    (v47 /*: any*/),
                    (v66 /*: any*/),
                    (v67 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v69 = ({
        "alias": null,
        "args": (v50 /*: any*/),
        "filters": (v64 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v70 = [
        (v48 /*: any*/),
        (v49 /*: any*/),
        (v59 /*: any*/)
    ], v71 = [
        (v68 /*: any*/),
        ({
            "alias": null,
            "args": null,
            "concreteType": "CommentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v12 /*: any*/),
                        (v51 /*: any*/),
                        (v56 /*: any*/),
                        (v54 /*: any*/),
                        (v27 /*: any*/),
                        (v30 /*: any*/),
                        (v31 /*: any*/),
                        (v16 /*: any*/),
                        (v32 /*: any*/),
                        (v33 /*: any*/),
                        (v34 /*: any*/),
                        (v35 /*: any*/),
                        (v53 /*: any*/),
                        (v28 /*: any*/),
                        (v36 /*: any*/),
                        (v37 /*: any*/),
                        (v55 /*: any*/),
                        (v26 /*: any*/),
                        (v38 /*: any*/),
                        (v52 /*: any*/),
                        (v45 /*: any*/),
                        (v46 /*: any*/),
                        (v47 /*: any*/),
                        (v39 /*: any*/),
                        (v66 /*: any*/),
                        (v67 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v61 /*: any*/)
            ],
            "storageKey": null
        } as any),
        (v62 /*: any*/)
    ], v72 = ({
        "alias": null,
        "args": (v70 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": (v71 /*: any*/),
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v73 = ({
        "alias": null,
        "args": (v70 /*: any*/),
        "filters": (v64 /*: any*/),
        "handle": "connection",
        "key": "ReplyList_replies",
        "kind": "LinkedHandle",
        "name": "replies"
    } as any), v74 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v12 /*: any*/),
                    (v51 /*: any*/),
                    (v56 /*: any*/),
                    (v54 /*: any*/),
                    (v27 /*: any*/),
                    (v30 /*: any*/),
                    (v31 /*: any*/),
                    (v16 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v35 /*: any*/),
                    (v53 /*: any*/),
                    (v28 /*: any*/),
                    (v36 /*: any*/),
                    (v37 /*: any*/),
                    (v55 /*: any*/),
                    (v26 /*: any*/),
                    (v38 /*: any*/),
                    (v52 /*: any*/),
                    (v45 /*: any*/),
                    (v46 /*: any*/),
                    (v47 /*: any*/),
                    (v72 /*: any*/),
                    (v73 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v75 = ({
        "alias": null,
        "args": (v70 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v74 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v12 /*: any*/),
                            (v51 /*: any*/),
                            (v56 /*: any*/),
                            (v54 /*: any*/),
                            (v27 /*: any*/),
                            (v30 /*: any*/),
                            (v31 /*: any*/),
                            (v16 /*: any*/),
                            (v32 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v35 /*: any*/),
                            (v53 /*: any*/),
                            (v28 /*: any*/),
                            (v36 /*: any*/),
                            (v37 /*: any*/),
                            (v55 /*: any*/),
                            (v26 /*: any*/),
                            (v38 /*: any*/),
                            (v52 /*: any*/),
                            (v45 /*: any*/),
                            (v46 /*: any*/),
                            (v47 /*: any*/),
                            (v72 /*: any*/),
                            (v73 /*: any*/),
                            (v39 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v61 /*: any*/)
                ],
                "storageKey": null
            },
            (v62 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v76 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v12 /*: any*/),
                    (v51 /*: any*/),
                    (v56 /*: any*/),
                    (v54 /*: any*/),
                    (v27 /*: any*/),
                    (v30 /*: any*/),
                    (v31 /*: any*/),
                    (v16 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v35 /*: any*/),
                    (v53 /*: any*/),
                    (v28 /*: any*/),
                    (v36 /*: any*/),
                    (v37 /*: any*/),
                    (v55 /*: any*/),
                    (v26 /*: any*/),
                    (v38 /*: any*/),
                    (v52 /*: any*/),
                    (v45 /*: any*/),
                    (v46 /*: any*/),
                    (v47 /*: any*/),
                    (v75 /*: any*/),
                    (v73 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v77 = ({
        "alias": null,
        "args": (v70 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v76 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v12 /*: any*/),
                            (v51 /*: any*/),
                            (v56 /*: any*/),
                            (v54 /*: any*/),
                            (v27 /*: any*/),
                            (v30 /*: any*/),
                            (v31 /*: any*/),
                            (v16 /*: any*/),
                            (v32 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v35 /*: any*/),
                            (v53 /*: any*/),
                            (v28 /*: any*/),
                            (v36 /*: any*/),
                            (v37 /*: any*/),
                            (v55 /*: any*/),
                            (v26 /*: any*/),
                            (v38 /*: any*/),
                            (v52 /*: any*/),
                            (v45 /*: any*/),
                            (v46 /*: any*/),
                            (v47 /*: any*/),
                            (v75 /*: any*/),
                            (v73 /*: any*/),
                            (v39 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v61 /*: any*/)
                ],
                "storageKey": null
            },
            (v62 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v78 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v12 /*: any*/),
                    (v51 /*: any*/),
                    (v56 /*: any*/),
                    (v54 /*: any*/),
                    (v27 /*: any*/),
                    (v30 /*: any*/),
                    (v31 /*: any*/),
                    (v16 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v35 /*: any*/),
                    (v53 /*: any*/),
                    (v28 /*: any*/),
                    (v36 /*: any*/),
                    (v37 /*: any*/),
                    (v55 /*: any*/),
                    (v26 /*: any*/),
                    (v38 /*: any*/),
                    (v52 /*: any*/),
                    (v45 /*: any*/),
                    (v46 /*: any*/),
                    (v47 /*: any*/),
                    (v77 /*: any*/),
                    (v73 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v79 = ({
        "alias": null,
        "args": (v70 /*: any*/),
        "concreteType": "CommentsConnection",
        "kind": "LinkedField",
        "name": "replies",
        "plural": false,
        "selections": [
            (v78 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v12 /*: any*/),
                            (v51 /*: any*/),
                            (v56 /*: any*/),
                            (v54 /*: any*/),
                            (v27 /*: any*/),
                            (v30 /*: any*/),
                            (v31 /*: any*/),
                            (v16 /*: any*/),
                            (v32 /*: any*/),
                            (v33 /*: any*/),
                            (v34 /*: any*/),
                            (v35 /*: any*/),
                            (v53 /*: any*/),
                            (v28 /*: any*/),
                            (v36 /*: any*/),
                            (v37 /*: any*/),
                            (v55 /*: any*/),
                            (v26 /*: any*/),
                            (v38 /*: any*/),
                            (v52 /*: any*/),
                            (v45 /*: any*/),
                            (v46 /*: any*/),
                            (v47 /*: any*/),
                            (v77 /*: any*/),
                            (v73 /*: any*/),
                            (v39 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v61 /*: any*/)
                ],
                "storageKey": null
            },
            (v62 /*: any*/)
        ],
        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
    } as any), v80 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v12 /*: any*/),
                    (v51 /*: any*/),
                    (v56 /*: any*/),
                    (v54 /*: any*/),
                    (v27 /*: any*/),
                    (v30 /*: any*/),
                    (v31 /*: any*/),
                    (v16 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v35 /*: any*/),
                    (v53 /*: any*/),
                    (v28 /*: any*/),
                    (v36 /*: any*/),
                    (v37 /*: any*/),
                    (v55 /*: any*/),
                    (v26 /*: any*/),
                    (v38 /*: any*/),
                    (v52 /*: any*/),
                    (v45 /*: any*/),
                    (v46 /*: any*/),
                    (v47 /*: any*/),
                    (v79 /*: any*/),
                    (v73 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v81 = ({
        "alias": null,
        "args": null,
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "viewNewEdges",
        "plural": true,
        "selections": [
            (v61 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v12 /*: any*/),
                    (v51 /*: any*/),
                    (v56 /*: any*/),
                    (v54 /*: any*/),
                    (v27 /*: any*/),
                    (v30 /*: any*/),
                    (v31 /*: any*/),
                    (v16 /*: any*/),
                    (v32 /*: any*/),
                    (v33 /*: any*/),
                    (v34 /*: any*/),
                    (v35 /*: any*/),
                    (v53 /*: any*/),
                    (v28 /*: any*/),
                    (v36 /*: any*/),
                    (v37 /*: any*/),
                    (v55 /*: any*/),
                    (v26 /*: any*/),
                    (v38 /*: any*/),
                    (v52 /*: any*/),
                    (v45 /*: any*/),
                    (v46 /*: any*/),
                    (v47 /*: any*/),
                    {
                        "alias": null,
                        "args": (v70 /*: any*/),
                        "concreteType": "CommentsConnection",
                        "kind": "LinkedField",
                        "name": "replies",
                        "plural": false,
                        "selections": [
                            (v80 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v12 /*: any*/),
                                            (v51 /*: any*/),
                                            (v56 /*: any*/),
                                            (v54 /*: any*/),
                                            (v27 /*: any*/),
                                            (v30 /*: any*/),
                                            (v31 /*: any*/),
                                            (v16 /*: any*/),
                                            (v32 /*: any*/),
                                            (v33 /*: any*/),
                                            (v34 /*: any*/),
                                            (v35 /*: any*/),
                                            (v53 /*: any*/),
                                            (v28 /*: any*/),
                                            (v36 /*: any*/),
                                            (v37 /*: any*/),
                                            (v55 /*: any*/),
                                            (v26 /*: any*/),
                                            (v38 /*: any*/),
                                            (v52 /*: any*/),
                                            (v45 /*: any*/),
                                            (v46 /*: any*/),
                                            (v47 /*: any*/),
                                            (v79 /*: any*/),
                                            (v73 /*: any*/),
                                            (v39 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    (v61 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v62 /*: any*/)
                        ],
                        "storageKey": "replies(first:10,orderBy:\"CREATED_AT_ASC\",refreshStream:false)"
                    },
                    (v73 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v82 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any), v83 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/),
                (v6 /*: any*/),
                (v7 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AllCommentsTabQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AllCommentsTabContainer_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v8 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v9 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "ratingFilter",
                                    "variableName": "ratingFilter"
                                },
                                (v10 /*: any*/),
                                (v11 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "AllCommentsTabContainer_story"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AllCommentsTabContainer_settings"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v4 /*: any*/),
                (v6 /*: any*/),
                (v0 /*: any*/),
                (v7 /*: any*/),
                (v5 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AllCommentsTabQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v12 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "current",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "kind": "LinkedField",
                                    "name": "ban",
                                    "plural": false,
                                    "selections": (v13 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "ignoredUsers",
                            "plural": true,
                            "selections": (v14 /*: any*/),
                            "storageKey": null
                        },
                        (v15 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scheduledDeletionDate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMediaSettings",
                            "kind": "LinkedField",
                            "name": "mediaSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "unfurlEmbeds",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserModerationScopes",
                            "kind": "LinkedField",
                            "name": "moderationScopes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scoped",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v16 /*: any*/),
                        (v17 /*: any*/),
                        (v18 /*: any*/),
                        (v19 /*: any*/),
                        (v20 /*: any*/),
                        (v21 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInPageNotificationSettings",
                            "kind": "LinkedField",
                            "name": "inPageNotifications",
                            "plural": false,
                            "selections": (v23 /*: any*/),
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "story",
                    "args": (v8 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        (v12 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "closedAt",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LiveConfiguration",
                                    "kind": "LinkedField",
                                    "name": "live",
                                    "plural": false,
                                    "selections": (v23 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mode",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoryMessageBox",
                                    "kind": "LinkedField",
                                    "name": "messageBox",
                                    "plural": false,
                                    "selections": [
                                        (v22 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "content",
                                            "storageKey": null
                                        },
                                        (v24 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "experts",
                                    "plural": true,
                                    "selections": (v14 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderation",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentCounts",
                            "kind": "LinkedField",
                            "name": "commentCounts",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalPublished",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentTagCounts",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "REVIEW",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "QUESTION",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v25 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v12 /*: any*/),
                                                (v26 /*: any*/),
                                                (v27 /*: any*/),
                                                (v28 /*: any*/),
                                                (v29 /*: any*/),
                                                (v30 /*: any*/),
                                                (v31 /*: any*/),
                                                (v16 /*: any*/),
                                                (v32 /*: any*/),
                                                (v33 /*: any*/),
                                                (v34 /*: any*/),
                                                (v35 /*: any*/),
                                                (v36 /*: any*/),
                                                (v37 /*: any*/),
                                                (v38 /*: any*/),
                                                (v45 /*: any*/),
                                                (v46 /*: any*/),
                                                (v47 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v50 /*: any*/),
                                                    "concreteType": "CommentsConnection",
                                                    "kind": "LinkedField",
                                                    "name": "replies",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v12 /*: any*/),
                                                                        (v51 /*: any*/),
                                                                        (v27 /*: any*/),
                                                                        (v30 /*: any*/),
                                                                        (v31 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        (v33 /*: any*/),
                                                                        (v34 /*: any*/),
                                                                        (v35 /*: any*/),
                                                                        (v28 /*: any*/),
                                                                        (v36 /*: any*/),
                                                                        (v37 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v38 /*: any*/),
                                                                        (v45 /*: any*/),
                                                                        (v46 /*: any*/),
                                                                        (v47 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v50 /*: any*/),
                                                                            "concreteType": "CommentsConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "replies",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "CommentEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v12 /*: any*/),
                                                                                                (v51 /*: any*/),
                                                                                                (v27 /*: any*/),
                                                                                                (v30 /*: any*/),
                                                                                                (v31 /*: any*/),
                                                                                                (v16 /*: any*/),
                                                                                                (v32 /*: any*/),
                                                                                                (v33 /*: any*/),
                                                                                                (v34 /*: any*/),
                                                                                                (v35 /*: any*/),
                                                                                                (v28 /*: any*/),
                                                                                                (v36 /*: any*/),
                                                                                                (v37 /*: any*/),
                                                                                                (v26 /*: any*/),
                                                                                                (v38 /*: any*/),
                                                                                                (v45 /*: any*/),
                                                                                                (v46 /*: any*/),
                                                                                                (v47 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": (v50 /*: any*/),
                                                                                                    "concreteType": "CommentsConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "replies",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "CommentEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Comment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        (v12 /*: any*/),
                                                                                                                        (v51 /*: any*/),
                                                                                                                        (v27 /*: any*/),
                                                                                                                        (v30 /*: any*/),
                                                                                                                        (v31 /*: any*/),
                                                                                                                        (v16 /*: any*/),
                                                                                                                        (v32 /*: any*/),
                                                                                                                        (v33 /*: any*/),
                                                                                                                        (v34 /*: any*/),
                                                                                                                        (v35 /*: any*/),
                                                                                                                        (v28 /*: any*/),
                                                                                                                        (v36 /*: any*/),
                                                                                                                        (v37 /*: any*/),
                                                                                                                        (v26 /*: any*/),
                                                                                                                        (v38 /*: any*/),
                                                                                                                        (v45 /*: any*/),
                                                                                                                        (v46 /*: any*/),
                                                                                                                        (v47 /*: any*/),
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": (v50 /*: any*/),
                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "replies",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": null,
                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": null,
                                                                                                                                            "concreteType": "Comment",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                (v12 /*: any*/),
                                                                                                                                                (v51 /*: any*/),
                                                                                                                                                (v27 /*: any*/),
                                                                                                                                                (v30 /*: any*/),
                                                                                                                                                (v31 /*: any*/),
                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                (v35 /*: any*/),
                                                                                                                                                (v28 /*: any*/),
                                                                                                                                                (v36 /*: any*/),
                                                                                                                                                (v37 /*: any*/),
                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                (v38 /*: any*/),
                                                                                                                                                (v45 /*: any*/),
                                                                                                                                                (v46 /*: any*/),
                                                                                                                                                (v47 /*: any*/),
                                                                                                                                                {
                                                                                                                                                    "alias": null,
                                                                                                                                                    "args": (v50 /*: any*/),
                                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "replies",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "alias": null,
                                                                                                                                                            "args": null,
                                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "edges",
                                                                                                                                                            "plural": true,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "alias": null,
                                                                                                                                                                    "args": null,
                                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "node",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        (v12 /*: any*/),
                                                                                                                                                                        (v51 /*: any*/),
                                                                                                                                                                        (v27 /*: any*/),
                                                                                                                                                                        (v30 /*: any*/),
                                                                                                                                                                        (v31 /*: any*/),
                                                                                                                                                                        (v16 /*: any*/),
                                                                                                                                                                        (v32 /*: any*/),
                                                                                                                                                                        (v33 /*: any*/),
                                                                                                                                                                        (v34 /*: any*/),
                                                                                                                                                                        (v35 /*: any*/),
                                                                                                                                                                        (v28 /*: any*/),
                                                                                                                                                                        (v36 /*: any*/),
                                                                                                                                                                        (v37 /*: any*/),
                                                                                                                                                                        (v26 /*: any*/),
                                                                                                                                                                        (v38 /*: any*/),
                                                                                                                                                                        (v45 /*: any*/),
                                                                                                                                                                        (v46 /*: any*/),
                                                                                                                                                                        (v47 /*: any*/),
                                                                                                                                                                        {
                                                                                                                                                                            "alias": null,
                                                                                                                                                                            "args": (v50 /*: any*/),
                                                                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "replies",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                {
                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                    "args": null,
                                                                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "edges",
                                                                                                                                                                                    "plural": true,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        {
                                                                                                                                                                                            "alias": null,
                                                                                                                                                                                            "args": null,
                                                                                                                                                                                            "concreteType": "Comment",
                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                            "name": "node",
                                                                                                                                                                                            "plural": false,
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                (v12 /*: any*/),
                                                                                                                                                                                                (v51 /*: any*/),
                                                                                                                                                                                                (v27 /*: any*/),
                                                                                                                                                                                                (v30 /*: any*/),
                                                                                                                                                                                                (v31 /*: any*/),
                                                                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                                                                (v35 /*: any*/),
                                                                                                                                                                                                (v28 /*: any*/),
                                                                                                                                                                                                (v36 /*: any*/),
                                                                                                                                                                                                (v37 /*: any*/),
                                                                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                                                                (v38 /*: any*/),
                                                                                                                                                                                                (v45 /*: any*/),
                                                                                                                                                                                                (v46 /*: any*/),
                                                                                                                                                                                                (v47 /*: any*/),
                                                                                                                                                                                                (v39 /*: any*/),
                                                                                                                                                                                                (v57 /*: any*/),
                                                                                                                                                                                                {
                                                                                                                                                                                                    "condition": "flattenReplies",
                                                                                                                                                                                                    "kind": "Condition",
                                                                                                                                                                                                    "passingValue": false,
                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                        {
                                                                                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                                                                                            "selections": (v58 /*: any*/)
                                                                                                                                                                                                        }
                                                                                                                                                                                                    ]
                                                                                                                                                                                                },
                                                                                                                                                                                                {
                                                                                                                                                                                                    "condition": "flattenReplies",
                                                                                                                                                                                                    "kind": "Condition",
                                                                                                                                                                                                    "passingValue": true,
                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                        {
                                                                                                                                                                                                            "alias": null,
                                                                                                                                                                                                            "args": (v60 /*: any*/),
                                                                                                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                                            "name": "replies",
                                                                                                                                                                                                            "plural": false,
                                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                                                    "args": null,
                                                                                                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                                                    "name": "edges",
                                                                                                                                                                                                                    "plural": true,
                                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                                        {
                                                                                                                                                                                                                            "alias": null,
                                                                                                                                                                                                                            "args": null,
                                                                                                                                                                                                                            "concreteType": "Comment",
                                                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                                                            "name": "node",
                                                                                                                                                                                                                            "plural": false,
                                                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                                                (v12 /*: any*/),
                                                                                                                                                                                                                                (v51 /*: any*/),
                                                                                                                                                                                                                                (v27 /*: any*/),
                                                                                                                                                                                                                                (v30 /*: any*/),
                                                                                                                                                                                                                                (v31 /*: any*/),
                                                                                                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                                                                                                (v35 /*: any*/),
                                                                                                                                                                                                                                (v28 /*: any*/),
                                                                                                                                                                                                                                (v36 /*: any*/),
                                                                                                                                                                                                                                (v37 /*: any*/),
                                                                                                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                                                                                                (v38 /*: any*/),
                                                                                                                                                                                                                                (v45 /*: any*/),
                                                                                                                                                                                                                                (v46 /*: any*/),
                                                                                                                                                                                                                                (v47 /*: any*/),
                                                                                                                                                                                                                                (v39 /*: any*/),
                                                                                                                                                                                                                                (v57 /*: any*/)
                                                                                                                                                                                                                            ],
                                                                                                                                                                                                                            "storageKey": null
                                                                                                                                                                                                                        },
                                                                                                                                                                                                                        (v39 /*: any*/),
                                                                                                                                                                                                                        (v61 /*: any*/)
                                                                                                                                                                                                                    ],
                                                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                                                },
                                                                                                                                                                                                                (v62 /*: any*/),
                                                                                                                                                                                                                {
                                                                                                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                                                                                                    "selections": [
                                                                                                                                                                                                                        (v63 /*: any*/)
                                                                                                                                                                                                                    ]
                                                                                                                                                                                                                }
                                                                                                                                                                                                            ],
                                                                                                                                                                                                            "storageKey": null
                                                                                                                                                                                                        },
                                                                                                                                                                                                        (v65 /*: any*/)
                                                                                                                                                                                                    ]
                                                                                                                                                                                                }
                                                                                                                                                                                            ],
                                                                                                                                                                                            "storageKey": null
                                                                                                                                                                                        },
                                                                                                                                                                                        (v61 /*: any*/)
                                                                                                                                                                                    ],
                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                },
                                                                                                                                                                                (v62 /*: any*/),
                                                                                                                                                                                {
                                                                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        (v68 /*: any*/)
                                                                                                                                                                                    ]
                                                                                                                                                                                }
                                                                                                                                                                            ],
                                                                                                                                                                            "storageKey": null
                                                                                                                                                                        },
                                                                                                                                                                        (v69 /*: any*/),
                                                                                                                                                                        (v39 /*: any*/),
                                                                                                                                                                        (v57 /*: any*/)
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": null
                                                                                                                                                                },
                                                                                                                                                                (v61 /*: any*/)
                                                                                                                                                            ],
                                                                                                                                                            "storageKey": null
                                                                                                                                                        },
                                                                                                                                                        (v62 /*: any*/),
                                                                                                                                                        {
                                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                                            "selections": [
                                                                                                                                                                (v74 /*: any*/)
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": null
                                                                                                                                                },
                                                                                                                                                (v69 /*: any*/),
                                                                                                                                                (v39 /*: any*/),
                                                                                                                                                (v57 /*: any*/)
                                                                                                                                            ],
                                                                                                                                            "storageKey": null
                                                                                                                                        },
                                                                                                                                        (v61 /*: any*/)
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                },
                                                                                                                                (v62 /*: any*/),
                                                                                                                                {
                                                                                                                                    "kind": "ClientExtension",
                                                                                                                                    "selections": [
                                                                                                                                        (v76 /*: any*/)
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v69 /*: any*/),
                                                                                                                        (v39 /*: any*/),
                                                                                                                        (v57 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v61 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v62 /*: any*/),
                                                                                                        {
                                                                                                            "kind": "ClientExtension",
                                                                                                            "selections": [
                                                                                                                (v78 /*: any*/)
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v69 /*: any*/),
                                                                                                (v39 /*: any*/),
                                                                                                (v57 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v61 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v62 /*: any*/),
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        (v80 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v69 /*: any*/),
                                                                        (v39 /*: any*/),
                                                                        (v57 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v61 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v62 /*: any*/),
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                (v81 /*: any*/)
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v69 /*: any*/),
                                                (v39 /*: any*/),
                                                (v57 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v61 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v62 /*: any*/),
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentEdge",
                                            "kind": "LinkedField",
                                            "name": "viewNewEdges",
                                            "plural": true,
                                            "selections": [
                                                (v61 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v12 /*: any*/),
                                                        (v26 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        (v56 /*: any*/),
                                                        (v54 /*: any*/),
                                                        (v30 /*: any*/),
                                                        (v31 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v35 /*: any*/),
                                                        (v53 /*: any*/),
                                                        (v36 /*: any*/),
                                                        (v37 /*: any*/),
                                                        (v55 /*: any*/),
                                                        (v38 /*: any*/),
                                                        (v52 /*: any*/),
                                                        (v45 /*: any*/),
                                                        (v46 /*: any*/),
                                                        (v47 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v50 /*: any*/),
                                                            "concreteType": "CommentsConnection",
                                                            "kind": "LinkedField",
                                                            "name": "replies",
                                                            "plural": false,
                                                            "selections": [
                                                                (v81 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CommentEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Comment",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v12 /*: any*/),
                                                                                (v51 /*: any*/),
                                                                                (v56 /*: any*/),
                                                                                (v54 /*: any*/),
                                                                                (v27 /*: any*/),
                                                                                (v30 /*: any*/),
                                                                                (v31 /*: any*/),
                                                                                (v16 /*: any*/),
                                                                                (v32 /*: any*/),
                                                                                (v33 /*: any*/),
                                                                                (v34 /*: any*/),
                                                                                (v35 /*: any*/),
                                                                                (v53 /*: any*/),
                                                                                (v28 /*: any*/),
                                                                                (v36 /*: any*/),
                                                                                (v37 /*: any*/),
                                                                                (v55 /*: any*/),
                                                                                (v26 /*: any*/),
                                                                                (v38 /*: any*/),
                                                                                (v52 /*: any*/),
                                                                                (v45 /*: any*/),
                                                                                (v46 /*: any*/),
                                                                                (v47 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": (v50 /*: any*/),
                                                                                    "concreteType": "CommentsConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "replies",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v80 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "CommentEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Comment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v12 /*: any*/),
                                                                                                        (v51 /*: any*/),
                                                                                                        (v56 /*: any*/),
                                                                                                        (v54 /*: any*/),
                                                                                                        (v27 /*: any*/),
                                                                                                        (v30 /*: any*/),
                                                                                                        (v31 /*: any*/),
                                                                                                        (v16 /*: any*/),
                                                                                                        (v32 /*: any*/),
                                                                                                        (v33 /*: any*/),
                                                                                                        (v34 /*: any*/),
                                                                                                        (v35 /*: any*/),
                                                                                                        (v53 /*: any*/),
                                                                                                        (v28 /*: any*/),
                                                                                                        (v36 /*: any*/),
                                                                                                        (v37 /*: any*/),
                                                                                                        (v55 /*: any*/),
                                                                                                        (v26 /*: any*/),
                                                                                                        (v38 /*: any*/),
                                                                                                        (v52 /*: any*/),
                                                                                                        (v45 /*: any*/),
                                                                                                        (v46 /*: any*/),
                                                                                                        (v47 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": (v50 /*: any*/),
                                                                                                            "concreteType": "CommentsConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "replies",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v78 /*: any*/),
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "Comment",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                (v12 /*: any*/),
                                                                                                                                (v51 /*: any*/),
                                                                                                                                (v56 /*: any*/),
                                                                                                                                (v54 /*: any*/),
                                                                                                                                (v27 /*: any*/),
                                                                                                                                (v30 /*: any*/),
                                                                                                                                (v31 /*: any*/),
                                                                                                                                (v16 /*: any*/),
                                                                                                                                (v32 /*: any*/),
                                                                                                                                (v33 /*: any*/),
                                                                                                                                (v34 /*: any*/),
                                                                                                                                (v35 /*: any*/),
                                                                                                                                (v53 /*: any*/),
                                                                                                                                (v28 /*: any*/),
                                                                                                                                (v36 /*: any*/),
                                                                                                                                (v37 /*: any*/),
                                                                                                                                (v55 /*: any*/),
                                                                                                                                (v26 /*: any*/),
                                                                                                                                (v38 /*: any*/),
                                                                                                                                (v52 /*: any*/),
                                                                                                                                (v45 /*: any*/),
                                                                                                                                (v46 /*: any*/),
                                                                                                                                (v47 /*: any*/),
                                                                                                                                {
                                                                                                                                    "alias": null,
                                                                                                                                    "args": (v50 /*: any*/),
                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "replies",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        (v76 /*: any*/),
                                                                                                                                        {
                                                                                                                                            "alias": null,
                                                                                                                                            "args": null,
                                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "alias": null,
                                                                                                                                                    "args": null,
                                                                                                                                                    "concreteType": "Comment",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        (v12 /*: any*/),
                                                                                                                                                        (v51 /*: any*/),
                                                                                                                                                        (v56 /*: any*/),
                                                                                                                                                        (v54 /*: any*/),
                                                                                                                                                        (v27 /*: any*/),
                                                                                                                                                        (v30 /*: any*/),
                                                                                                                                                        (v31 /*: any*/),
                                                                                                                                                        (v16 /*: any*/),
                                                                                                                                                        (v32 /*: any*/),
                                                                                                                                                        (v33 /*: any*/),
                                                                                                                                                        (v34 /*: any*/),
                                                                                                                                                        (v35 /*: any*/),
                                                                                                                                                        (v53 /*: any*/),
                                                                                                                                                        (v28 /*: any*/),
                                                                                                                                                        (v36 /*: any*/),
                                                                                                                                                        (v37 /*: any*/),
                                                                                                                                                        (v55 /*: any*/),
                                                                                                                                                        (v26 /*: any*/),
                                                                                                                                                        (v38 /*: any*/),
                                                                                                                                                        (v52 /*: any*/),
                                                                                                                                                        (v45 /*: any*/),
                                                                                                                                                        (v46 /*: any*/),
                                                                                                                                                        (v47 /*: any*/),
                                                                                                                                                        {
                                                                                                                                                            "alias": null,
                                                                                                                                                            "args": (v50 /*: any*/),
                                                                                                                                                            "concreteType": "CommentsConnection",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "replies",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                (v74 /*: any*/),
                                                                                                                                                                {
                                                                                                                                                                    "alias": null,
                                                                                                                                                                    "args": null,
                                                                                                                                                                    "concreteType": "CommentEdge",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "edges",
                                                                                                                                                                    "plural": true,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "alias": null,
                                                                                                                                                                            "args": null,
                                                                                                                                                                            "concreteType": "Comment",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "node",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                (v12 /*: any*/),
                                                                                                                                                                                (v51 /*: any*/),
                                                                                                                                                                                (v56 /*: any*/),
                                                                                                                                                                                (v54 /*: any*/),
                                                                                                                                                                                (v27 /*: any*/),
                                                                                                                                                                                (v30 /*: any*/),
                                                                                                                                                                                (v31 /*: any*/),
                                                                                                                                                                                (v16 /*: any*/),
                                                                                                                                                                                (v32 /*: any*/),
                                                                                                                                                                                (v33 /*: any*/),
                                                                                                                                                                                (v34 /*: any*/),
                                                                                                                                                                                (v35 /*: any*/),
                                                                                                                                                                                (v53 /*: any*/),
                                                                                                                                                                                (v28 /*: any*/),
                                                                                                                                                                                (v36 /*: any*/),
                                                                                                                                                                                (v37 /*: any*/),
                                                                                                                                                                                (v55 /*: any*/),
                                                                                                                                                                                (v26 /*: any*/),
                                                                                                                                                                                (v38 /*: any*/),
                                                                                                                                                                                (v52 /*: any*/),
                                                                                                                                                                                (v45 /*: any*/),
                                                                                                                                                                                (v46 /*: any*/),
                                                                                                                                                                                (v47 /*: any*/),
                                                                                                                                                                                {
                                                                                                                                                                                    "alias": null,
                                                                                                                                                                                    "args": (v50 /*: any*/),
                                                                                                                                                                                    "concreteType": "CommentsConnection",
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "replies",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": (v71 /*: any*/),
                                                                                                                                                                                    "storageKey": null
                                                                                                                                                                                },
                                                                                                                                                                                (v69 /*: any*/),
                                                                                                                                                                                (v39 /*: any*/)
                                                                                                                                                                            ],
                                                                                                                                                                            "storageKey": null
                                                                                                                                                                        },
                                                                                                                                                                        (v61 /*: any*/)
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": null
                                                                                                                                                                },
                                                                                                                                                                (v62 /*: any*/)
                                                                                                                                                            ],
                                                                                                                                                            "storageKey": null
                                                                                                                                                        },
                                                                                                                                                        (v69 /*: any*/),
                                                                                                                                                        (v39 /*: any*/)
                                                                                                                                                    ],
                                                                                                                                                    "storageKey": null
                                                                                                                                                },
                                                                                                                                                (v61 /*: any*/)
                                                                                                                                            ],
                                                                                                                                            "storageKey": null
                                                                                                                                        },
                                                                                                                                        (v62 /*: any*/)
                                                                                                                                    ],
                                                                                                                                    "storageKey": null
                                                                                                                                },
                                                                                                                                (v69 /*: any*/),
                                                                                                                                (v39 /*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                        },
                                                                                                                        (v61 /*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                (v62 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v69 /*: any*/),
                                                                                                        (v39 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v61 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v62 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v69 /*: any*/),
                                                                                (v39 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v61 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v62 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v69 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v25 /*: any*/),
                            "filters": [
                                "orderBy",
                                "tag",
                                "rating",
                                "refreshStream"
                            ],
                            "handle": "connection",
                            "key": "Stream_comments",
                            "kind": "LinkedHandle",
                            "name": "comments"
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Site",
                            "kind": "LinkedField",
                            "name": "site",
                            "plural": false,
                            "selections": [
                                (v12 /*: any*/),
                                (v82 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "viewerRating",
                            "plural": false,
                            "selections": [
                                (v12 /*: any*/),
                                (v32 /*: any*/),
                                (v35 /*: any*/),
                                (v33 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v40 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryRatings",
                            "kind": "LinkedField",
                            "name": "ratings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "count",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "average",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerCount",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canModerate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchiving",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchived",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "kind": "LinkedField",
                            "name": "reaction",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "labelActive",
                                    "storageKey": null
                                },
                                (v24 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "iconActive",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "InPageNotificationsConfiguration",
                            "kind": "LinkedField",
                            "name": "inPageNotifications",
                            "plural": false,
                            "selections": (v13 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "kind": "LinkedField",
                            "name": "disableCommenting",
                            "plural": false,
                            "selections": [
                                (v22 /*: any*/),
                                (v83 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featureFlags",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "kind": "LinkedField",
                            "name": "charCount",
                            "plural": false,
                            "selections": [
                                (v22 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "min",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "max",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "kind": "LinkedField",
                            "name": "closeCommenting",
                            "plural": false,
                            "selections": [
                                (v83 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaConfiguration",
                            "kind": "LinkedField",
                            "name": "media",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TwitterMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "twitter",
                                    "plural": false,
                                    "selections": (v23 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BlueskyMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "bluesky",
                                    "plural": false,
                                    "selections": (v23 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "YouTubeMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "youtube",
                                    "plural": false,
                                    "selections": (v23 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GifMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "gifs",
                                    "plural": false,
                                    "selections": [
                                        (v22 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "key",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maxRating",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "provider",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExternalMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "external",
                                    "plural": false,
                                    "selections": (v23 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "RTEConfiguration",
                            "kind": "LinkedField",
                            "name": "rte",
                            "plural": false,
                            "selections": [
                                (v22 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "strikethrough",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "spoiler",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sarcasm",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "flattenReplies",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "collapseReplies",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TopCommenterConfiguration",
                            "kind": "LinkedField",
                            "name": "topCommenter",
                            "plural": false,
                            "selections": (v23 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "NewCommenterConfiguration",
                            "kind": "LinkedField",
                            "name": "newCommenter",
                            "plural": false,
                            "selections": (v23 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "kind": "LinkedField",
                                    "name": "integrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SSOAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "sso",
                                            "plural": false,
                                            "selections": [
                                                (v22 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AuthenticationTargetFilter",
                                                    "kind": "LinkedField",
                                                    "name": "targetFilter",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "admin",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmbeddedCommentsConfiguration",
                            "kind": "LinkedField",
                            "name": "embeddedComments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "allowReplies",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DSAConfiguration",
                            "kind": "LinkedField",
                            "name": "dsa",
                            "plural": false,
                            "selections": (v23 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberBios",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "BadgeConfiguration",
                            "kind": "LinkedField",
                            "name": "badges",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "staffLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "adminLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "moderatorLabel",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "memberLabel",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                                (v82 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contactEmail",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "FlairBadgeConfiguration",
                            "kind": "LinkedField",
                            "name": "flairBadges",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "flairBadgesEnabled",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlairBadge",
                                    "kind": "LinkedField",
                                    "name": "badges",
                                    "plural": true,
                                    "selections": [
                                        (v82 /*: any*/),
                                        (v40 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v12 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "9c28aa927a6d4ee29ff476337d9563b4",
            "metadata": {},
            "name": "AllCommentsTabQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '70bb0e534f1c6287b5f38ebbaab2203a';
export default node;
